import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import UpdateIcon from '@mui/icons-material/Update';
import { Button, Divider, Grid, Typography } from '@mui/material';

const IssuesTab = ({ open, toggle, invalidValues }) => {
  const DialogWrapper = styled(Dialog)(
    () => `
                  .MuiDialog-container {
                      height: 100vh;
                  }
                  
                  .MuiDialog-paperScrollPaper {
                      max-height: calc(100vh - 80px)
                  }
              `
  );
  return (
    <DialogWrapper
      open={open}
      keepMounted
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <Grid sx={{ px: 2, mt: '0.5rem' }} container spacing={2}>
        <Grid item xs={12}>
          <Typography
            style={{
              color: '#223354',
              fontWeight: '700',
              fontSize: '15px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
            sx={{ pb: 1 }}
            variant="h4"
          >
            Issues Found
          </Typography>
        </Grid>
        <Grid
          display="flex"
          flexDirection="column"
          sx={{ px: 2, mt: '0.1rem' }}
          container
          spacing={2}
        >
          <Divider />
          {invalidValues.map((val, index) => (
            <>
              <Grid display="flex" alignItems="center" item>
                <UpdateIcon
                  color="error"
                  fontSize="small"
                  sx={{ mb: 2, mr: 2 }}
                />
                <Typography
                  style={{
                    color: '#000000',
                    fontSize: '12px'
                  }}
                  sx={{ pb: 2 }}
                  variant="body2"
                  fontWeight="bold"
                >
                  {val.error}
                </Typography>
                <Typography
                  style={{ marginLeft: 'auto', fontSize: '11px' }}
                  sx={{ pb: 2 }}
                  variant="body2"
                >
                  Row No: {val.row}
                </Typography>
              </Grid>
              <Divider />
            </>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}></Grid>
          <Grid
            style={{
              marginTop: '3rem',
              marginBottom: '1rem'
            }}
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
            xs={6}
          >
            <Button variant="outlined" onClick={() => toggle()}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </DialogWrapper>
  );
};

export default IssuesTab;
